module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/undo-369725e20b28c62e352d69bffca4755d.svg";